<t4-header icon="glyphicon-inbox" title="{{ 'Turbo.Messages.Inbox_Headline' | translate:'Inbox'}}" subtitle="{{ 'Turbo.Messages.Inbox_Tagline' | translate:'Received messages'}}"></t4-header>


<button (click)="new()">New</button>